<template>
    <ValidationObserver :ref="stepName" v-slot="observer">

        <div v-for="(field,name) in fields" :key="name" class="field-container">
            <component :is="field._component" :key="name" :name="name" :field="field" :step="step"></component>
        </div>
        <b-button type="button next-button is-primary" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>


    </ValidationObserver>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import modal_mixin from "../../../../../../views/_commons/nl/mixins/modal_mixin";
import form_step_mixin from '../../../form_step_mixin'
import EvoPhoneText from "../../../../fields/EvoPhoneText";
import {Text} from "../../../../../../models/fields/Text";
import {MaskPattern} from "../../../../../../models/fields/Features/mask/MaskPattern";
import {Checkbox} from "../../../../../../models/fields/Checkbox";
import Vue from "vue";

export default {
    mixins: [mixin,form_step_mixin, modal_mixin],
    data() {
        return {
            fields: {
                phone: new Text().component(EvoPhoneText).required()
                    .mask(new MaskPattern('{+32} {4}00 000000'))
                .validation({
                    regex: /^\+324(5|6|7|8|9)\d{7}$/
                }),
                optin_privacy: new Checkbox()
                    .label(this.generateOptinLabel('<div>Ik verklaar de <a @click.prevent="openModal(\'infos\',\'privacy\')">privacybepalingen</a> dat zal worden gebruikt voor de administratieve en commerciële follow-up van mijn aanvraag heb gelezen en aanvaard.</div>')).required(),

            }
        }
    },
    methods: {
        generateOptinLabel(template){
            let compiledComponent = Vue.compile(template);
            let componentLogic = {
                mixins: [modal_mixin]
            }
            return {...compiledComponent, ...componentLogic}
        },
    },
    mounted() {
        if(this.$store.get('form_data/iban')==this.$store.get('func_data/test_iban')){
            this.$store.set('general_data/is_test',1);
            this.fields.phone = new Text().component(EvoPhoneText).required()
                .mask(new MaskPattern('{+}[0000000000000000]'))
        }else{
            if(this.$store.get('general_data/is_test') == 1){
                console.log('RESET PHONE')
                this.$store.set('form_data/phone',null);
            }
            this.$store.set('general_data/is_test',0);
        }
    }
}
</script>
<style>
.next-button{
    max-width: unset;
}
</style>
